import React from 'react';
import { Box } from '@mui/material';
import { isUsableImageUrl } from '../utils/itineraryItemImage';

/**
 * Wide partner lockups are light type on dark. Never crop them square and
 * never sit them on cream — use the partner banner (or black) as a plate.
 */
const PartnerLockup = ({
  src,
  alt = '',
  banner,
  height = 48,
  maxWidth = 220,
  sx = {},
}) => {
  if (!isUsableImageUrl(src)) return null;
  const plate = /^#[0-9a-fA-F]{6}$/.test(String(banner || '')) ? banner : '#000000';

  return (
    <Box
      data-testid="partner-lockup"
      sx={{
        bgcolor: plate,
        px: 1.5,
        py: 1,
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        component="img"
        src={String(src).trim()}
        alt={alt}
        sx={{
          height,
          width: 'auto',
          maxWidth,
          objectFit: 'contain',
          objectPosition: 'left center',
          display: 'block',
        }}
      />
    </Box>
  );
};

export default PartnerLockup;
